<template>
  <div>
    <table class="table" >
      <thead>
        <tr>
          <th>冷蔵庫ID</th>
          <th>会社名-拠点名-フロア</th>
          <th>ロス数</th>
          <th>持ち帰り数</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="maintenance in maintenanceList">
          <td>{{maintenance.boxId}}</td>
          <td>{{maintenance.boxPlaceName}}</td>
          <td>
            <button
              class="btn"
              :class="{ 'checked': maintenance.isCheckLossQuantity1 && maintenance.isCheckLossQuantity2 }"
              @click="lossCheck(maintenance.boxId)"
              v-if="maintenance.hasLossItems1 || maintenance.hasLossItems2"
            >
              {{ maintenance.isCheckLossQuantity1 && maintenance.isCheckLossQuantity2 ? '確認済み' : '確認する'}}
            </button>
          </td>
          <td>
            <button
              class="btn"
              :class="{ 'checked': maintenance.isCheckTakeoutQuantity1 && maintenance.isCheckTakeoutQuantity2 }"
              @click="takeoutCheck(maintenance.boxId)"
              v-if=" maintenance.hasTakeoutItems1 || maintenance.hasTakeoutItems2"
            >
              {{ maintenance.isCheckTakeoutQuantity1 && maintenance.isCheckTakeoutQuantity2 ? '確認済み' : '確認する'}}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'MaintenanceCheck',
    created() {
      this.$parent.title = 'ロス・持ち帰り数確認';
      this.$parent.imageName = '';
      this.$parent.showMaintenanceInformation = false;
      this.$parent.hasMaintenancne = false;
    },
    computed: {
      ...mapGetters([
        'maintenanceList',
      ]),
    },
    methods: {
      lossCheck(boxId) {
        this.searchBox('LossCheck', boxId)
      },
      takeoutCheck(boxId) {
        this.searchBox('TakeoutCheck', boxId)
      },
      searchBox(type, boxId) {
        this.$store.dispatch('getMaintenanceData', { boxId: boxId })
          .then(() => { this.$router.push({ name: type }); })
          .catch((e) => {
            if (e.status == 401) {
              alert(e.data.error.message);
              this.$router.push({ name: 'SignIn', replace: true })
              return;
            }
            alert(e.data.error.message);
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  div {
    padding-top: 1rem;

    td {
      button {
        background: #CBDAF5;

        &.checked {
          background: #FDF2D0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MaintenanceCheck.vue?f0998ff8